import { render, staticRenderFns } from "./detailsWarehouseReceiptRecord.vue?vue&type=template&id=190817b3&scoped=true"
import script from "./detailsWarehouseReceiptRecord.vue?vue&type=script&lang=js"
export * from "./detailsWarehouseReceiptRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsWarehouseReceiptRecord.vue?vue&type=style&index=0&id=190817b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190817b3",
  null
  
)

export default component.exports